import React from 'react';
import { API } from '../../../lib/api';

const WikiModals = ({
  editingFaq,
  editingGuide,
  editingSystem,
  faqForm,
  guideForm,
  handleCreateFaq,
  handleCreateGuide,
  handleCreateSystem,
  handleUpdateFaq,
  handleUpdateGuide,
  handleUpdateSystem,
  handleUploadDocument,
  setEditingFaq,
  setEditingGuide,
  setEditingSystem,
  setFaqForm,
  setGuideForm,
  setShowDocumentModal,
  setShowFaqModal,
  setShowGuideModal,
  setShowSystemModal,
  setSystemForm,
  setUploadDescription,
  setUploadFile,
  showDocumentModal,
  showErrorNotification,
  showFaqModal,
  showGuideModal,
  showSystemModal,
  systemForm,
  uploadDescription,
  uploadFile,
  uploading
}) => {
  return (
    <>
{showSystemModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">
              {editingSystem ? 'System bearbeiten' : 'Neues System erstellen'}
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                <input
                  type="text"
                  value={systemForm.name}
                  onChange={(e) => setSystemForm({...systemForm, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="z.B. Deutsche Glasfaser"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Beschreibung</label>
                <textarea
                  value={systemForm.description}
                  onChange={(e) => setSystemForm({...systemForm, description: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="3"
                  placeholder="Beschreibung des Systems..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Typ</label>
                <select
                  value={systemForm.type}
                  onChange={(e) => setSystemForm({...systemForm, type: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="client">Auftraggeber</option>
                  <option value="internal">Internes System</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">System-Link (URL)</label>
                <input
                  type="url"
                  value={systemForm.system_url}
                  onChange={(e) => setSystemForm({...systemForm, system_url: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="z.B. https://www.beispiel.de"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Logo hochladen</label>
                <div className="space-y-3">
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png,.svg"
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const formData = new FormData();
                        formData.append('file', file);
                        
                        try {
                          const uploadResponse = await fetch(`${API}/process-systems/upload-logo`, {
                            method: 'POST',
                            headers: {
                              'Authorization': `Bearer ${localStorage.getItem('token')}`
                            },
                            body: formData
                          });
                          
                          if (uploadResponse.ok) {
                            const uploadResult = await uploadResponse.json();
                            setSystemForm({
                              ...systemForm, 
                              logo_url: uploadResult.logo_url
                            });
                          } else {
                            console.error('Logo upload failed:', uploadResponse.statusText);
                            showErrorNotification('Logo-Upload fehlgeschlagen. Bitte versuchen Sie es erneut.');
                          }
                        } catch (error) {
                          console.error('Logo upload error:', error);
                          showErrorNotification('Fehler beim Logo-Upload');
                        }
                      }
                    }}
                    className="w-full text-sm border border-gray-300 rounded-lg file:mr-2 file:py-2 file:px-3 file:rounded file:border-0 file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                  />
                  {systemForm.logo_url && (
                    <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                      <img 
                        src={`${API}/system-logos/${systemForm.logo_url.split('/').pop()}`}
                        alt="Logo Vorschau"
                        className="w-12 h-12 object-contain rounded"
                      />
                      <div className="flex-1">
                        <div className="text-sm text-green-600 font-medium">✅ Logo hochgeladen</div>
                        <div className="text-xs text-gray-500">Wird automatisch angezeigt</div>
                      </div>
                      <button
                        type="button"
                        onClick={() => setSystemForm({...systemForm, logo_url: ''})}
                        className="text-red-600 hover:text-red-800 p-1"
                        title="Logo entfernen"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-4 mt-6">
              <button
                onClick={() => {
                  console.log('❌ AdminPanel Modal cancel clicked');
                  setShowSystemModal(false);
                  setEditingSystem(null);
                  setSystemForm({ name: '', description: '', type: 'client', system_url: '', order: 0, logo_url: '' });
                }}
                className="px-6 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
              >
                Abbrechen
              </button>
              <button
                onClick={() => {
                  console.log('🖱️ BUTTON CLICKED! AdminPanel Modal submit button clicked');
                  console.log('✅ AdminPanel Modal submit clicked, editing system:', editingSystem);
                  console.log('📋 Current systemForm:', systemForm);
                  if (editingSystem) {
                    console.log('🔄 Calling handleUpdateSystem...');
                    handleUpdateSystem();
                  } else {
                    console.log('🔄 Calling handleCreateSystem...');
                    handleCreateSystem();
                  }
                }}
                className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
              >
                {editingSystem ? 'Aktualisieren' : 'Erstellen'}
              </button>
            </div>
          </div>
        </div>
      )}

{showGuideModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">
              {editingGuide ? 'Anleitung bearbeiten' : 'Neue Anleitung erstellen'}
            </h2>
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Titel</label>
                <input
                  type="text"
                  value={guideForm.title}
                  onChange={(e) => setGuideForm({...guideForm, title: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="z.B. Deutsche Glasfaser Bestellprozess"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Beschreibung (Optional)</label>
                <textarea
                  value={guideForm.description || ''}
                  onChange={(e) => setGuideForm({...guideForm, description: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="2"
                  placeholder="Kurze Beschreibung der Anleitung..."
                />
              </div>
              
              {/* Steps Management */}
              <div>
                <div className="flex items-center justify-between mb-4">
                  <label className="block text-sm font-medium text-gray-700">Schritte</label>
                  <button
                    type="button"
                    onClick={() => {
                      const currentSteps = guideForm.steps || [];
                      setGuideForm({
                        ...guideForm, 
                        steps: [
                          ...currentSteps,
                          {
                            step_number: currentSteps.length + 1,
                            title: '',
                            description: '',
                            screenshot_file_path: '',
                            screenshot_filename: ''
                          }
                        ]
                      });
                    }}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded-lg text-sm font-medium transition-colors"
                  >
                    + Schritt hinzufügen
                  </button>
                </div>
                
                <div className="space-y-4 max-h-96 overflow-y-auto">
                  {(guideForm.steps || []).map((step, index) => (
                    <div key={index} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                      <div className="flex items-center justify-between mb-3">
                        <h4 className="font-medium text-gray-900">Schritt {step.step_number || index + 1}</h4>
                        <button
                          type="button"
                          onClick={() => {
                            const newSteps = guideForm.steps.filter((_, i) => i !== index);
                            // Reorder step numbers
                            const reorderedSteps = newSteps.map((s, i) => ({
                              ...s,
                              step_number: i + 1
                            }));
                            setGuideForm({...guideForm, steps: reorderedSteps});
                          }}
                          className="text-red-600 hover:text-red-800"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1H9a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                      
                      <div className="space-y-3">
                        <input
                          type="text"
                          value={step.title}
                          onChange={(e) => {
                            const newSteps = [...guideForm.steps];
                            newSteps[index] = { ...newSteps[index], title: e.target.value };
                            setGuideForm({...guideForm, steps: newSteps});
                          }}
                          placeholder="z.B. Login im Auftraggeber-System"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        
                        <textarea
                          value={step.description}
                          onChange={(e) => {
                            const newSteps = [...guideForm.steps];
                            newSteps[index] = { ...newSteps[index], description: e.target.value };
                            setGuideForm({...guideForm, steps: newSteps});
                          }}
                          placeholder="Beschreibung des Schritts..."
                          rows="3"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        
                        <div className="grid grid-cols-1 gap-3">
                          {/* Screenshot Upload */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Screenshot (JPG, PNG, PDF)
                            </label>
                            <input
                              type="file"
                              accept=".jpg,.jpeg,.png,.pdf"
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  // Upload file immediately
                                  const formData = new FormData();
                                  formData.append('file', file);
                                  
                                  try {
                                    const uploadResponse = await fetch(`${API}/process-guides/upload-screenshot`, {
                                      method: 'POST',
                                      headers: {
                                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                                      },
                                      body: formData
                                    });
                                    
                                    if (uploadResponse.ok) {
                                      const uploadResult = await uploadResponse.json();
                                      const newSteps = [...guideForm.steps];
                                      newSteps[index] = { 
                                        ...newSteps[index], 
                                        screenshot_file_path: uploadResult.file_path,
                                        screenshot_filename: uploadResult.filename
                                      };
                                      setGuideForm({...guideForm, steps: newSteps});
                                    } else {
                                      console.error('Upload failed:', uploadResponse.statusText);
                                      showErrorNotification('Screenshot upload fehlgeschlagen. Bitte versuchen Sie es erneut.');
                                    }
                                  } catch (error) {
                                    console.error('Upload error:', error);
                                    showErrorNotification('Fehler beim Screenshot-Upload');
                                  }
                                }
                              }}
                              className="w-full text-sm border border-gray-300 rounded-lg file:mr-2 file:py-1 file:px-2 file:rounded file:border-0 file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                            />
                            {step.screenshot_filename && (
                              <div className="mt-2 text-sm text-green-600 flex items-center">
                                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                {step.screenshot_filename}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  
                  {(!guideForm.steps || guideForm.steps.length === 0) && (
                    <div className="text-center py-8 text-gray-500">
                      <svg className="w-12 h-12 mx-auto mb-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                      Noch keine Schritte hinzugefügt. Klicken Sie auf "Schritt hinzufügen" um zu beginnen.
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-4 mt-6 pt-4 border-t">
              <button
                onClick={() => {
                  setShowGuideModal(false);
                  setEditingGuide(null);
                  setGuideForm({ title: '', description: '', steps: [], order: 0 });
                }}
                className="px-6 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
              >
                Abbrechen
              </button>
              <button
                onClick={editingGuide ? handleUpdateGuide : handleCreateGuide}
                className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors"
                disabled={!guideForm.title.trim()}
              >
                {editingGuide ? 'Aktualisieren' : 'Erstellen'}
              </button>
            </div>
          </div>
        </div>
      )}

{showFaqModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-2xl">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">
              {editingFaq ? 'FAQ bearbeiten' : 'Neue FAQ erstellen'}
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Frage</label>
                <input
                  type="text"
                  value={faqForm.question}
                  onChange={(e) => setFaqForm({...faqForm, question: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="z.B. Wie lange dauert die Bestellung?"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Antwort</label>
                <textarea
                  value={faqForm.answer}
                  onChange={(e) => setFaqForm({...faqForm, answer: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="5"
                  placeholder="Detaillierte Antwort auf die Frage..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Kategorie (optional)</label>
                <input
                  type="text"
                  value={faqForm.category}
                  onChange={(e) => setFaqForm({...faqForm, category: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="z.B. Häufige Fehler, Technische Fragen"
                />
              </div>
            </div>
            <div className="flex justify-end space-x-4 mt-6">
              <button
                onClick={() => {
                  setShowFaqModal(false);
                  setEditingFaq(null);
                  setFaqForm({ question: '', answer: '', category: '', order: 0 });
                }}
                className="px-6 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
              >
                Abbrechen
              </button>
              <button
                onClick={editingFaq ? handleUpdateFaq : handleCreateFaq}
                className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
              >
                {editingFaq ? 'Aktualisieren' : 'Erstellen'}
              </button>
            </div>
          </div>
        </div>
      )}

{showDocumentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">
              Dokument hochladen
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Datei auswählen</label>
                <input
                  type="file"
                  onChange={(e) => setUploadFile(e.target.files[0])}
                  accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                {uploadFile && (
                  <div className="mt-2 text-sm text-gray-600">
                    📄 {uploadFile.name} ({Math.round(uploadFile.size / 1024)} KB)
                  </div>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Beschreibung (optional)</label>
                <input
                  type="text"
                  value={uploadDescription}
                  onChange={(e) => setUploadDescription(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="z.B. Anleitung für Bestellformular"
                />
              </div>
            </div>
            <div className="flex justify-end space-x-4 mt-6">
              <button
                onClick={() => {
                  setShowDocumentModal(false);
                  setUploadFile(null);
                  setUploadDescription('');
                }}
                className="px-6 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
              >
                Abbrechen
              </button>
              <button
                onClick={handleUploadDocument}
                disabled={!uploadFile || uploading}
                className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {uploading ? (
                  <div className="flex items-center">
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                    Wird hochgeladen...
                  </div>
                ) : (
                  'Hochladen'
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WikiModals;
